import { WorkOrderData } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/data/_components/work-order-data";
import { useParams } from "react-router";

export function DataRoute() {
  const { workOrderId } = useParams();

  return <WorkOrderData workOrderId={workOrderId!} />;
}
